import React, { useEffect, useRef, useState } from 'react';

type Dir = "up" | "down";

export function Move2TopButton({view, scrollToElement}:{view?:any, scrollToElement?: string}){
    const [hidden, setHidden] = useState(true);
    const [direction, setDir] = useState<Dir>(null);
    const ignore = useRef(false);
    
    if(typeof view == 'string'){
        view = document.querySelector(view);
    }

    view = view || document.querySelector('body');
    

    scrollToElement = scrollToElement || 'body';
        
	function click(){
		document.querySelector(scrollToElement).scrollIntoView({behavior: "smooth", block: direction == 'up' ? 'start' : 'end'});
        ignore.current = true;
		setHidden(true);
        setTimeout(() => ignore.current = false, 1000);
	}
	
    useEffect(function(){
        var hideHandle:any = 0;
        var oldTop = 0;
        
        function scrolled(){
            if(ignore.current) 
                return;
            if(hideHandle)
                clearInterval(hideHandle);
            setHidden(false);

            setDir(view.scrollTop > oldTop ? "down" : "up");
            oldTop = view.scrollTop;            

            hideHandle = setTimeout(() => setHidden(true), 2000);
        }

        view.addEventListener('scroll', scrolled);

        return () => {
            view.removeEventListener('scroll', scrolled);
        }

	}, [view]);

    return <a style={{position:"sticky", bottom: "50px", right: "20px"}} className={`to-top-button ${hidden ? 'button-hidden' : ''}`} onClick={click}>
            <i className={`fa ${direction == 'down' ? 'fa-arrow-down' : 'fa-arrow-up'}`}></i>
        </a>
}